import {isRetinaDisplay} from '../helpers'
const htmlFontTransform = () => {
	const devicePixel = 1 / window.devicePixelRatio
	if(!isRetinaDisplay()) {
		document.documentElement.style.fontSize = devicePixel * 16 + 'px';
	}
}

export default htmlFontTransform;
